import qs from 'qs';
import { useLocation } from 'react-router-dom';

export const useIsUserFromIndeed = (): boolean => {
  const location = useLocation();
  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });
  const utmSource = queryParams.utm_source;

  if (typeof utmSource === 'string') {
    const isUserFromIndeed = utmSource.toLowerCase().includes('indeed');
    return isUserFromIndeed;
  }

  return false;
};
